import React from 'react';
import cx from 'classnames';
import Proptypes from 'prop-types';

import { UNORDERED_LIST_DEFINITIONS } from '@xingternal/content-editor-plugin-helpers';

import { UNORDERED_LIST_TAG_NAME } from './constants';
import styles from './UnorderedList.css';

const renderer = ({
  node: { type },
  UNORDERED_LIST_TAG = UNORDERED_LIST_TAG_NAME,
  ...attributes
}) => {
  if (type === UNORDERED_LIST_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <UNORDERED_LIST_TAG
        className={cx(styles.unorderedList, attributes.className)}
        {...restOfAttributes}
        data-editor-plugin="unorderedList"
      >
        {children}
      </UNORDERED_LIST_TAG>
    );
  }
};

renderer.Proptypes = {
  node: Proptypes.object,
  attributes: Proptypes.object,
};

export { renderer };
